<ion-header>
  <app-navheader></app-navheader>
	<ion-item lines="none" class="factsheetssubcat-name" *ngIf="theme">
    <ion-label>
      <div class="factsheet-subcat-title"><h1>{{theme.name}}</h1></div>
    </ion-label>
	</ion-item>
</ion-header>
<ion-content [ngClass]="themeClass" class="ion-no-padding">
	<ion-list *ngIf="theme">
    <ion-item lines="none" class="factsheet-name" *ngFor="let subtheme of subthemes" (click)="goToFileDetail(subtheme)">
      <ion-label>
        <img class="factsheet-icon" src="../../../assets/img/factsheet-icon.png" />
        <span>{{ subtheme.name }}</span>
      </ion-label>
    </ion-item>
	</ion-list>
  <ion-list *ngIf="subthemesResp">
    <ion-item lines="none" class="factsheet-name" *ngFor="let subtheme of subthemesResp" (click)="goToFileDetail(subtheme)">
      <ion-label>
        <img class="factsheet-icon" src="../../../assets/img/factsheet-icon.png" />
        <span>{{ subtheme.name }}</span>
      </ion-label>
    </ion-item>
	</ion-list>
	<app-cookie-info></app-cookie-info>
</ion-content>
<ion-footer> <app-bottom-menu [isActive]="isActivePage"></app-bottom-menu></ion-footer>
<app-pop-up [show] = "tempPopUp" [data] = "popup" #temppopup></app-pop-up>
<ion-spinner *ngIf="showSpinner" name="lines" color="primary"></ion-spinner>
